import { navigateTo } from '#app'

/**
 * Utilidad para middlewares que hacen fetch y guardan en un store/reactive.
 * @param fetcher función que ejecuta la petición (por ejemplo, get de useOFetchCustom)
 * @param storeRef ref/reactive donde guardar la data
 * @param options opciones adicionales: { onSuccess, onError, redirectOnError }
 */
export async function middlewareFetch<T = any>(
  fetcher: (onSuccess: (data: T) => void, onError: (error: any) => void) => void,
  storeRef: { value: any },
  options?: {
    onSuccess?: (data: T) => void
    onError?: (error: any) => void
    redirectOnError?: string | ((error: any) => string | void)
  }
) {
  try {
    await new Promise((resolve, reject) => {
      fetcher(
        (response: T) => {
          storeRef.value = response
          options?.onSuccess?.(response)
          resolve(response)
        },
        (error: any) => {
          options?.onError?.(error)
          reject(error)
        }
      )
    })
  } catch (error: any) {
    let redirectPath: string | void = undefined
    if (typeof options?.redirectOnError === 'function') {
      redirectPath = options.redirectOnError(error)
    } else if (typeof options?.redirectOnError === 'string') {
      redirectPath = options.redirectOnError
    }
    if (redirectPath) {
      return navigateTo(redirectPath)
    }
  }
} 